import { render, staticRenderFns } from "./kredikartnoara.vue?vue&type=template&id=f4fb5fc2&"
import script from "./kredikartnoara.vue?vue&type=script&lang=js&"
export * from "./kredikartnoara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports